<template>
  <ValidationProvider rules="required">
    <Checkbox
      class="mt-5"
      v-model="selectedOptions"
      :selectedValues="selectedOptions"
      @change="value => handleChange(value)"
      :options="questionOptions"
      isLarge
      isColumn
      mixed
    />
    <div
      v-if="showValidationErrors && isEmpty(selectedOptions)"
      class="text-error mb-5"
    >
      This field is required
    </div>
  </ValidationProvider>
</template>

<script>
import Checkbox from "@/components/common/Checkbox";
import { ValidationProvider } from "vee-validate";
import { map, isEmpty, first, size } from "lodash";
import {
  getAnswerIdByValue,
  getAnswerValueById
} from "@/views/profile/QuestionsAndAnswers/utils";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    ValidationProvider,
    Checkbox
  },
  data() {
    return {
      selectedOptions: []
    };
  },
  created() {
    const { answerData, options } = this.question;
    if (answerData && size(answerData.answers)) {
      this.selectedOptions = map(answerData.answers, answer =>
        getAnswerIdByValue({
          questionOptions: options,
          answer
        })
      );
    }
  },
  computed: {
    questionOptions() {
      return map(this.question.options, option => ({
        label: option.option,
        value: option.id
      }));
    }
  },
  methods: {
    handleChange(value) {
      this.selectedOptions = value;
      this.$emit("onChange", {
        answers: map(this.selectedOptions, selectedOption =>
          getAnswerValueById({
            questionOptions: this.question.options,
            id: selectedOption
          })
        ),
        question: {
          type: "booking-application-questions",
          id: this.question.id
        }
      });
    },
    first,
    isEmpty
  }
};
</script>

<style lang="scss" scoped></style>
